import { useState } from "react";

const useApiErrorHandler = () => {
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleToastClose = () => {
    setToast((prevToast) => ({ ...prevToast, open: false }));
  };

  const handleApiError = (err) => {
    // Log the full error for debugging
    console.error("API Error:", {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
      fullError: err,
    });

    // Extract the actual error message from the API response
    const apiMessage = 
      err.response?.data?.message || 
      err.response?.data?.error || 
      err.response?.data?.detail ||
      err.message;

    const errorMessage =
      err.response?.status === 403
        ? "You are not authorized."
        : err.response?.status === 404
          ? `Data could not be found. ${apiMessage}`
          : err.response?.status === 400
            ? apiMessage // Show the API's validation/business logic error message
            : err.response?.status === 409
              ? `Conflict occurred: ${apiMessage}`
              : err.response?.status === 500
                ? `Server Error: ${apiMessage}`
                : `Something went wrong. ${apiMessage}`;

    setToast({ open: true, message: errorMessage, severity: "error" });
  };

  return { handleApiError, toast, setToast, handleToastClose };
};

export default useApiErrorHandler;
